import React, { FC, PropsWithChildren } from 'react'

interface FullscreenModalProps {
  show: boolean
  onClose?: () => void
  cardBg?: boolean
}

const PDModal: FC<PropsWithChildren<FullscreenModalProps>> = ({ show, onClose, children, cardBg = true }) => {
  if (!show) return null

  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center z-[51] px-6"
      onClick={onClose}
    >
      {cardBg ? <div
        className="laptop:w-508px p-6 bg-white rounded-2xl flex-col justify-start items-start gap-6 inline-flex"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full flex justify-between">
          <img src="/icons/icon_pudu.svg" alt="" />
          <button
            className="w-6 h-6 bg-black/60 rounded-[18px] backdrop-blur-md flex justify-center items-center"
            onClick={onClose}
          >
            <img src="/icons/icon_close_white.svg" alt="" className="w-3 h-3" />
          </button>
        </div>
        {children}
      </div> : children}
    </div>
  )
}

export default PDModal
